import React from 'react'
import Navbar from '../Navbar'
import Footer from '../Footer'

const MainLayout = ({ children }) => {
    return (
        <div className="">
            <Navbar />
            <main className="overflow-hidden bg-gray-100">{children}</main>
            <Footer />
        </div>
    )
}

export default MainLayout